import Paper from "@mui/material/Paper";
import GetAppIcon from "@mui/icons-material/GetApp";
import ListItemIcon from "@mui/material/ListItemIcon";
import SubTabsBase from "../../components/2compounds/SubTabsBase";

const iconStyles = { minWidth: "40px" };
const primaryTypographyProps = { fontWeight: 700 };

const AuditLogSideMenu = ({ selectedTabIndex, setSelectedTabIndex }) => {
    // Left Menu Items
    const AuditLogMenuItems = [{ label: "Audit Trail", description: "" }];

    const listItemIcon = (
        <ListItemIcon sx={iconStyles}>
            <GetAppIcon />
        </ListItemIcon>
    );

    return (
        <Paper>
            <SubTabsBase
                menuItems={AuditLogMenuItems}
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={setSelectedTabIndex}
                listItemIcon={listItemIcon}
                primaryTypographyProps={primaryTypographyProps}
            />
        </Paper>
    );
};

export default AuditLogSideMenu;
